module.exports = __webpack_public_path__ + "static/media/alert-circle.5e85cff9.svg";